import { render, staticRenderFns } from "./passenger-selection-row.vue?vue&type=template&id=21b99722"
import script from "./passenger-selection-row.vue?vue&type=script&lang=js"
export * from "./passenger-selection-row.vue?vue&type=script&lang=js"
import style0 from "./passenger-selection-row.vue?vue&type=style&index=0&id=21b99722&prod&class=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports